<template>
  <Teleport to="body">
    <div
      v-if="visible"
      class="dev-toolbar"
      :class="{ 'dev-toolbar--collapsed': collapsed }"
    >
      <!-- Toggle visibility -->
      <button class="dev-toolbar-toggle" @click="collapsed = !collapsed" :title="collapsed ? 'Mostrar dev toolbar' : 'Ocultar'">
        <span v-if="collapsed" class="dev-toolbar-dot" :style="{ background: mode === 'local' ? '#22c55e' : '#3b82f6' }"></span>
        <span v-else>✕</span>
      </button>

      <div v-if="!collapsed" class="dev-toolbar-body">
        <span class="dev-toolbar-label">API:</span>
        <div class="dev-toolbar-buttons">
          <button
            class="dev-toolbar-btn"
            :class="{ 'is-active': mode === 'prod' }"
            @click="setMode('prod')"
          >
            Prod
          </button>
          <button
            class="dev-toolbar-btn"
            :class="{ 'is-active': mode === 'local' }"
            @click="setMode('local')"
          >
            Local
          </button>
        </div>
        <span v-if="mode === 'local'" class="dev-toolbar-active-label">← Activo</span>

        <!-- Input para pegar token manual (útil en local sin login form) -->
        <div class="dev-toolbar-token" :class="{ 'is-visible': mostrarTokenInput }">
          <button class="dev-toolbar-token-toggle" @click="mostrarTokenInput = !mostrarTokenInput" title="Pegar token manual">
            <i>🔑</i>
          </button>
          <div v-if="mostrarTokenInput" class="dev-toolbar-token-form">
            <input
              v-model="tokenManual"
              type="text"
              placeholder="Pega el token aquí..."
              class="dev-toolbar-token-input"
              @keydown.enter="aplicarTokenManual"
            />
            <button class="dev-toolbar-btn dev-toolbar-btn--apply" @click="aplicarTokenManual">
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
export default {
  name: 'DevToolbar',
  data() {
    return {
      visible: true,
      collapsed: false,
      mode: 'prod',
      mostrarTokenInput: false,
      tokenManual: '',
    };
  },
  mounted() {
    this.mode = localStorage.getItem('dev_api_mode') || 'prod';

    // Limpiar llaves viejas del diseño anterior (backup temporal)
    localStorage.removeItem('dev_token_prod_backup');
    localStorage.removeItem('dev_clientData_backup');
  },
  methods: {
    setMode(mode) {
      if (mode === this.mode) return;

      // Guardar permanentemente los tokens del modo actual antes de cambiar
      const modoActual = this.mode;
      const tokenActual = localStorage.getItem('token');
      const clientDataActual = localStorage.getItem('clientData');
      if (tokenActual) localStorage.setItem('dev_token_' + modoActual, tokenActual);
      if (clientDataActual) localStorage.setItem('dev_clientData_' + modoActual, clientDataActual);

      // Cambiar al nuevo modo
      this.mode = mode;
      localStorage.setItem('dev_api_mode', mode);

      // Restaurar tokens del modo destino (si existen guardados)
      const tokenDestino = localStorage.getItem('dev_token_' + mode);
      const clientDataDestino = localStorage.getItem('dev_clientData_' + mode);
      if (tokenDestino) {
        localStorage.setItem('token', tokenDestino);
        if (clientDataDestino) {
          localStorage.setItem('clientData', clientDataDestino);
        }
      } else {
        // No hay token guardado para este modo → login limpio
        localStorage.removeItem('token');
        localStorage.removeItem('clientData');
      }

      window.location.reload();
    },

    async aplicarTokenManual() {
      const token = (this.tokenManual || '').trim();
      if (!token) return;

      // Detectar modo actual: si estamos en prod, guarda como prod; si en local, como local
      const modoActual = localStorage.getItem('dev_api_mode') || 'prod';
      const endpoint = modoActual === 'local' ? '/api-local/user' : '/api/user';
      const key = modoActual === 'local' ? 'local' : 'prod';
      const label = modoActual === 'local' ? 'local' : 'producción';

      // Poner el token temporalmente para validar
      localStorage.setItem('dev_api_mode', modoActual);
      this.mode = modoActual;
      localStorage.setItem('token', token);

      try {
        const axios = (await import('axios')).default;
        const res = await axios.post(endpoint, { token });
        const body = res.data;

        if (body && body.user && !body.error) {
          // Guardar token PERMANENTEMENTE para este modo
          localStorage.setItem('dev_token_' + key, token);
          localStorage.setItem('dev_clientData_' + key, JSON.stringify(body.user));
          localStorage.setItem('clientData', JSON.stringify(body.user));
          window.location.href = '/dashboard';
        } else {
          alert('Token inválido para ' + label + '. Verifica que el usuario exista en la BD ' + label + '.');
          localStorage.removeItem('token');
        }
      } catch (e) {
        alert('Error de conexión al backend ' + label + ' (' + e.message + ').');
        localStorage.removeItem('token');
      }
    },
  },
};
</script>

<style scoped>
.dev-toolbar {
  position: fixed;
  bottom: 16px;
  right: 16px;
  z-index: 99999;
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(15, 23, 42, 0.92);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(148, 163, 184, 0.3);
  border-radius: 12px;
  padding: 8px 12px;
  font-size: 0.75rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  transition: all 0.2s ease;
}

.dev-toolbar--collapsed {
  padding: 6px;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  justify-content: center;
}

.dev-toolbar-toggle {
  background: none;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  font-size: 0.85rem;
  padding: 2px 4px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dev-toolbar-toggle:hover {
  color: #e2e8f0;
}

.dev-toolbar-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: block;
}

.dev-toolbar-body {
  display: flex;
  align-items: center;
  gap: 8px;
}

.dev-toolbar-label {
  color: #94a3b8;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-size: 0.68rem;
}

.dev-toolbar-buttons {
  display: flex;
  gap: 4px;
}

.dev-toolbar-btn {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(148, 163, 184, 0.25);
  border-radius: 6px;
  padding: 3px 10px;
  color: #94a3b8;
  font-size: 0.72rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
}

.dev-toolbar-btn:hover {
  border-color: rgba(148, 163, 184, 0.5);
  color: #e2e8f0;
}

.dev-toolbar-btn.is-active {
  border-color: rgba(59, 130, 246, 0.6);
  background: rgba(59, 130, 246, 0.2);
  color: #60a5fa;
}

.dev-toolbar-btn.is-active:first-child.is-active {
  border-color: rgba(59, 130, 246, 0.6);
}

.dev-toolbar-btn.is-active:last-child.is-active {
  border-color: rgba(34, 197, 94, 0.6);
  background: rgba(34, 197, 94, 0.2);
  color: #4ade80;
}

.dev-toolbar-active-label {
  color: #4ade80;
  font-size: 0.68rem;
  font-weight: 600;
  animation: devPulse 2s ease-in-out infinite;
}

@keyframes devPulse {
  0%, 100% { opacity: 0.7; }
  50% { opacity: 1; }
}
</style>
